import { format, parseISO } from 'date-fns'
import { ru, enUS } from 'date-fns/locale'

const getLocale = locale => {
  switch (locale) {
    case 'ru':
      return ru
    // case 'uz':
    //   return uz
    case 'en':
      return enUS
    default:
      return ru
  }
}

export const date = (date, locale) => {
  if (!date) return ''
  let parsedDate = format(parseISO(date), 'dd MMM yyyy', {
    locale: getLocale(locale),
  })
  return parsedDate
}

export const time = (date, locale) => {
  if (!date) return ''
  let parsedDate = format(parseISO(date), 'hh:mm BBB', {
    locale: getLocale(locale),
  })
  return parsedDate
}
